import {
  IonButtons,
  IonContent,
  IonGrid,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
  useIonViewWillEnter,
} from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { resetDocumentList, setSegmentSelected } from "../../store/documentsSignerList";
import { fetchDocuments } from "../../store/documentsSignerList/actions/fetchDocuments";
import { selectDocumentCount } from "../../store/documentsSignerList/selectors/selectDocumentCount";
import { useParams } from "react-router";
import { WithDocuments } from "./components/WithDocuments";
import { WithoutDocuments } from "./components/WithoutDocuments";

export const SignerDocumentsFromALink: React.FC = () => {
  const dispatch = useDispatch();
  const { channel }: { channel: string } = useParams();

  const count = useSelector(selectDocumentCount);

  useIonViewWillEnter(() => {
    dispatch(setSegmentSelected("pending"));
    dispatch(resetDocumentList());
    dispatch(fetchDocuments());
  }, [dispatch]);

  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonTitle>Acuerdos</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonGrid fixed={true} style={{ height: "100%" }}>
          {count > 0 ? <WithDocuments count={count} /> : <WithoutDocuments />}
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};
